const config = {
    instruments : [
        "WiFeS"
    ],
    topends: [
        "PF",
        "F/8",
        "F/15",
        "F/36",
        "CS36",
        "F/1",
        "2DF",
    ],
    /*obs_type:[
        {value:"Object",name:"RUN"}, //#Object
        {value:"BIAS",name:"BIAS"},
        {value:"DARK",name:"DARK"},
        {value:"FLAT",name:"FLAT"},
        {value:"FFLAT",name:"FFLAT"},
        {value:"ARC",name:"ARC"},
        {value:"ANY",name:"ANY"} // add to allow user filer data
    ],
    obs_type_df:[
        {value:"MFOBJECT",name:"OBJECT"}, //#Object
        {value:"DARK",name:"Dark"},
        {value:"BIAS",name:"Bias"},
        {value:"MFSKY",name:"Offset Sky"},
        {value:"SFLAT",name:"Offset Flat"},
        {value:"DFLAT",name:"Detector Flat"},
        {value:"MFFFF",name:"Fiber Flat"},
        {value:"MFARC",name:"Arc"},
        {value:"MFFLX",name:"Flux Cal"}
    ],
    //
    obs_type_herme:[
        {value:"DARK",name:"Dark"},
        {value:"BIAS",name:"Bias"},
        {value:"LFLAT",name:"LFLAT"},
        {value:"MFARC",name:"Arc"},
        {value:"MFFFF",name:"Fiber Flat"},
        {value:"MFFLX",name:"Flux Cal"},
        {value:"MFOBJECT",name:"OBJECT"}, //#Object
        {value:"MFSKY",name:"Offset Sky"},
        {value:"SFLAT",name:"Offset Flat"},
        {value:"DFLAT",name:"Detector Flat"},
        {value:"ANY",name:"ANY"} // add to allow user filer data
    ],*/
    obs_type:[
        {value: "OBJECT",name:"Object"},
        {value: "COMMON OBJECT",name:"Common Object"},
        {value:"ARC",name:"Arc"},
        {value: "SKYFLAT",name:"Sky Flat"},
        {value: "WIRE",name:"Wire"},
        {value: "FLAT",name:"Flat"},
        {value: "STANDARD",name:"Standard"},
        {value: "BIAS",name:"Bias"},
        {value: "DARK",name:"Dark"},
        {value: "ANY", name:"Any"}
    ]
}

module.exports = config;

